import { createFileRoute } from '@tanstack/react-router'

import { BackofficeAdminImaPage as PlatformAdminImaPage } from '../../../../components/pages/backoffice/platform/platform-admin-ima-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/admin/ima')({
  component: () => (
    <PermissionChecker requiredPermissions={['tech.configurations']}>
      <PlatformAdminImaPage />
    </PermissionChecker>
  ),
})
